import { memo, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Button,
  Drawer,
  CardContent,
  Card,
  CardHeader,
  Tabs,
  Tab,
  Stack,
  Typography,
  Pagination, Backdrop,
} from '@mui/material';
import {
  SvgArrowNarrowRightFill,
  SvgCloseFill,
  SvgDotFill,
} from '../../SvgIcons';
import Scrollbar from '../../scrollbar';
import { COMMENT_FLAG, READ_FLAG } from '../../../store/types';
import { LoadingScreen } from '../../loading-screen';
import { NoData } from '../../error';
import { onChangeFeedbackTabsItem, onFeedbackArchived, queryFeedbackDetails, queryFeedbackList, toggleFeedbackListDrawer } from '../../../store/actions/feebackActions';
import { SimSystemList } from '../../list';
import { queryUnreadNotificationTotal } from '../../../store/actions/slices/notificationActions';


// components

// store

/* ======================================================================================= */

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="SimTabs-indicatorSpan" /> }}
  />
))(({ theme }) => ({
  overflow: 'visible',
  '& .MuiTabs-scroller': {
    overflow: 'visible !important'
  },
  '& .MuiTabs-indicator': {
    bottom: -1,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .SimTabs-indicatorSpan': {
    maxWidth: 42, // 56
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
  },
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    ...theme.typography.body2,
    textTransform: 'none',
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
    '&.Mui-focusVisible': {
      // backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
);
/* =========================================================================== */

function CustomTabPanel(props) {
  const { children, value, index, loading, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box position={'relative'} p={3} height={'calc(100vh - 45px - 49px)'} sx={{ overflowY: 'auto' }}>
          <Backdrop
            sx={{
              position: 'absolute',
              textAlign: 'center',
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={Boolean(loading)}
          >
            <LoadingScreen />
          </Backdrop>
          {children}
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
};
function a11yProps(index) {
  return {
    id: `notification-tab-${index}`,
    'aria-controls': `notification-tabpanel-${index}`,
  };
}



const NotificationContent = ({ readFlag, list = [], total = 0, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage, pages, handleViewDetails }) => {
  const theme = useTheme();
  return list?.length > 0 ? (
    <Box role="presentation">
      <Scrollbar sx={{ height: '78vh' }}>
        <List disablePadding sx={{ pb: 0.25 }}>
          {_.map(list, (item, index) => (
            <ListItem key={index} disablePadding sx={{ ...theme.typography.hoverPrimaryLeftline2px }} onClick={() => handleViewDetails(item)}>
              <ListItemButton
                sx={{
                  py: 1.5,
                  pl: 1.5,
                  pr: 3,
                  position: 'relative',
                  overflow: 'hidden',
                  borderBottom: '1px solid #CCC',
                  '& .MuiListItemText-root': {
                    m: 0,
                    position: 'relative',
                    overflow: 'hidden'
                  },
                  '& .Sim-icon-link': {
                    width: 0,
                    lineHeight: 0,
                    pl: 3,
                    transform: 'translateX(70px)',
                    transition: 'all 0.3s 0s ease-out',
                  },
                  '&:hover': {
                    backgroundColor: theme => theme.palette.action.hover,
                    '& .Sim-icon-link': {
                      width: 46,
                      transform: 'translateX(0px)'
                    }
                  }
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      mb={1}
                      display={'block'}
                      component="span"
                      variant="subtitle1"
                      fontWeight={item?.avatar ? 700 : 400}
                      color="text.primary"
                      sx={{ ...theme.typography.lineClamp1 }}
                    >
                      {
                        [READ_FLAG.Unread].includes(Number(item?.readFlag)) && (
                          <Box component={'i'} width={6} display={'inline-block'} mr={1} sx={{ verticalAlign: 'text-bottom' }}>
                            <SvgDotFill />
                          </Box>
                        )
                      }
                      {item?.titile}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant={'body2'}
                      color={'text.secondary'}
                      display={'flex'}
                      alignItems={'center'}
                    >
                      {item?.sendTime}
                      {item?.sysBmApplication?.applicationName && (<Divider sx={{ width: 3, height: 3, alignSelf: 'center', mx: 1 }} color={'error.main'} orientation="vertical" variant="middle" flexItem />)}
                      {item?.sysBmApplication?.applicationName}
                    </Typography>
                  }
                />
                <Box className={'Sim-icon-link'}>
                  <SvgArrowNarrowRightFill />
                </Box>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Scrollbar>
      <Stack width={'100%'} direction={'row'} spacing={2} py={3} alignItems={'center'} justifyContent={'center'}>
        {/* <Box>共&nbsp;{ total }&nbsp;筆</Box> */}
        {/* <FormControl sx={{ m: 1, minWidth: '5rem' }} size="small" className="mx-0 my-0">
          <Select value={rowsPerPage} onChange={handleChangeRowsPerPage} displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
            {_.map([10, 20, 30, 40], (option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <Pagination
          variant={'text'}
          shape="rounded"
          size={'medium'}
          count={pages}
          page={page}
          defaultPage={page}
          onChange={handleChangePage}
        />
        {/* <Box display={'flex'} alignItems={'center'}>
          <Typography variant={'h6'} fontWeight={400}>跳至</Typography>
          <TextField
            id="outlined-size-small"
            defaultValue=""
            size="small"
            sx={{
              mx: 1,
              '& .MuiInputBase-root': {
                maxHeight: 32,
                maxWidth: 64
              }
            }}
          />
          <Typography variant={'h6'} fontWeight={400}>頁</Typography>
        </Box> */}
      </Stack>
    </Box>
  ) : (<NoData />)
};
NotificationContent.propTypes = {
  readFlag: PropTypes.number,
  list: PropTypes.array,
  total: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  pages: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  handleViewDetails: PropTypes.func
};

/* ======================================================================================= */

const FeedbackList = ({ ct }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { feedback } = useSelector(state => state);

  const { state, commit } = useContext(ct);
  
  const handleTabChange = async (event, newValue) => {
    dispatch(onChangeFeedbackTabsItem(newValue));
  };

  const handleChangePage = async (event, newPage) => {
    await dispatch(queryFeedbackList({ page: newPage, rowsPerPage: feedback?.rowsPerPage, messageStatus: feedback?.messageStatus }));
  };

  const handleChangeRowsPerPage = (event) => {
  };

  const handleLink = (event, item) => {
    dispatch(queryFeedbackDetails(item));
    // commit({
    //   type: 'OPEN_DETAILS_DRAWER',
    //   data: {
    //     ...state,
    //     visible: true,
    //     record: item,
    //     messageStatus
    //   }
    // });
  };

  const handleClose = () => {
    dispatch(toggleFeedbackListDrawer(false));
    handleChangePage(_, COMMENT_FLAG.All);
  };

  useEffect(() => {
    (async function() {
      if(Boolean(feedback?.isOpenFeedbackList)) {
        dispatch(onChangeFeedbackTabsItem(COMMENT_FLAG.All));
        // await dispatch(queryFeedbackList({ page: feedback?.page, rowsPerPage: feedback?.rowsPerPage, messageStatus: feedback?.messageStatus }));
      };
    })();
  }, [feedback?.isOpenFeedbackList]);

  return (
    <Drawer
      variant={'temporary'}
      anchor={'right'}
      open={Boolean(feedback?.isOpenFeedbackList)}
      // onClose={toggleDrawer(false)}
    >
      {/* 516 532 */}
      <Card sx={{ width: 532, borderRadius: 0 }}>
        <CardHeader
          atrr-title={'有話要說'}
          title={t('有話要說')}
          action={<Box onClick={() => handleClose()} sx={{ cursor: 'pointer' }}><SvgCloseFill color={'text.primary'} /></Box>}
          sx={{
            py: 1.75,
            pl: 3,
            pr: 2,
            borderBottom: '1px solid #CCC',
            '& .MuiCardHeader-action': {
              m: 0,
              lineHeight: 0
            }
          }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0, borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs 
              value={feedback?.messageStatus} 
              onChange={handleTabChange} 
              aria-label="notification drawer tabs"
          >
              <StyledTab label="全部" value={COMMENT_FLAG.All} {...a11yProps(COMMENT_FLAG.All)} />
              <StyledTab label="未回復" value={COMMENT_FLAG.Unreply} {...a11yProps(COMMENT_FLAG.Unreply)} />
              <StyledTab label="已回復" value={COMMENT_FLAG.Replied} {...a11yProps(COMMENT_FLAG.Replied)} />
          </StyledTabs>
          <Button variant='outlined' disabled={feedback?.existFeedback <= 0} onClick={() => dispatch(onFeedbackArchived())}>標記為已讀</Button>
        </CardContent>
        <CardContent sx={{ p: 0 }}>
          <CustomTabPanel value={feedback?.messageStatus} index={COMMENT_FLAG.All}>
              <SimSystemList
                hideHeader
                hideJumper
                hideRowsPerPage
                variant={'feedback'}
                itemMinHeight={72}
                loading={feedback?.isLoading}
                list={feedback?.list}
                page={feedback?.page}
                defaultPage={feedback?.page}
                rowsPerPage={feedback?.rowsPerPage}
                total={feedback?.total}
                count={feedback?.pages}
                onChangePage={handleChangePage}
                onLink={(event, item) => handleLink(event, item)}
              />
          </CustomTabPanel>
          <CustomTabPanel value={feedback?.messageStatus} index={COMMENT_FLAG.Unreply}>
              <SimSystemList
                hideHeader
                hideJumper
                hideRowsPerPage
                variant={'feedback'}
                itemMinHeight={72}
                loading={feedback?.isLoading}
                list={feedback?.list}
                page={feedback?.page}
                defaultPage={feedback?.page}
                rowsPerPage={feedback?.rowsPerPage}
                total={feedback?.total}
                count={feedback?.pages}
                onChangePage={handleChangePage}
                onLink={(event, item) => handleLink(event, item)}
              />
          </CustomTabPanel>
          <CustomTabPanel value={feedback?.messageStatus} index={COMMENT_FLAG.Replied}>
              <SimSystemList
                hideHeader
                hideJumper
                hideRowsPerPage
                variant={'feedback'}
                itemMinHeight={72}
                loading={feedback?.isLoading}
                list={feedback?.list}
                page={feedback?.page}
                defaultPage={feedback?.page}
                rowsPerPage={feedback?.rowsPerPage}
                total={feedback?.total}
                count={feedback?.pages}
                onChangePage={handleChangePage}
                onLink={(event, item) => handleLink(event, item)}
              />
          </CustomTabPanel>
        </CardContent>
      </Card>
    </Drawer>
  );
};

export default memo(FeedbackList);
